import { render, staticRenderFns } from "./WebAppSubscriptionGrid.vue?vue&type=template&id=515fc850&scoped=true"
import script from "./WebAppSubscriptionGrid.vue?vue&type=script&lang=js"
export * from "./WebAppSubscriptionGrid.vue?vue&type=script&lang=js"
import style0 from "./WebAppSubscriptionGrid.vue?vue&type=style&index=0&id=515fc850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fc850",
  null
  
)

export default component.exports